import Image from 'next/image'
import React from 'react'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

type IdePraktikHeaderProps = {
  onBack: () => void
  title: string
  subtitle: string
}

const IdePraktikHeader = ({
  onBack,
  subtitle,
  title,
}: IdePraktikHeaderProps) => {
  return (
    <div className="bg-[#0036a3] flex-shrink-0">
      <HeaderBar borderless variant="transparent">
        <HeaderBarLeftAction
          icon={
            <Icon color="inverse" as="i">
              arrow_back
            </Icon>
          }
          onClick={() => {
            onBack()
          }}
        />
        <HeaderBarTitle>
          <Text color="inverse" variant="heading-sm">
            Ide Praktik
          </Text>
        </HeaderBarTitle>
      </HeaderBar>
      <div className="p-4 pt-0">
        <div className="mb-3 flex items-center gap-3">
          <div className="w-[60px] h-[60px]">
            <Image
              layout="fixed"
              src="/icon/ide-praktik.svg"
              alt=""
              width={60}
              height={60}
            />
          </div>
          <Text color="inverse" variant="heading-md">
            {title}
          </Text>
        </div>
        <Text color="inverse" variant="body-sm">
          {subtitle}
        </Text>
      </div>
    </div>
  )
}

export default IdePraktikHeader
